import { slugifyPathSegment } from './fundraiserUrl'

export const createInitialFormData = () => ({
  campaignName: '',
  campaignType: 'Donation Campaign',
  description: '',
  goalAmount: '',
  startDate: '',
  endDate: '',
  status: 'Draft',
  connectionType: 'Entire Organization',
  eventUuid: '',
  selectedSeasonUuids: [],
  selectedPackageUuids: [],
  donationRules: [],
  applyFundraiserTo: 'All tickets',
  donationPromptDuringCheckout: 'Yes',
  defaultDonationAmounts: ['$5', '$10', '$25', 'Custom'],
  enableParticipantFundraising: 'No',
  participantType: 'Player',
  participants: [],
  allowPublicParticipantPages: 'Yes',
  showLeaderboard: 'Yes',
  addCorporateSponsors: 'No',
  companyName: '',
  sponsorshipType: 'Matching Donation',
  contactName: '',
  contactEmail: '',
  logoFileName: '',
  website: '',
  displaySponsorPublicly: 'Yes',
  donationAmount: '',
  matchAmount: '100%',
  maximumMatch: '',
  amountPerTicket: '',
  maximumContribution: '',
  businessOffer: '',
  trackingCode: '',
  pageUrlSlug: '',
  bannerFileName: '',
  primaryColor: '#0057b8',
  showGoalProgress: 'Yes',
  showRecentDonors: 'Yes',
  showDonorMessages: 'Yes',
  showSponsorLogos: 'Yes',
  ctaButton: 'Donate Now',
  secondaryButton: 'Buy Tickets',
  showDonationInCheckout: 'Yes',
  donationTitle: '',
  donationDescription: '',
  suggestedAmounts: ['$5', '$10', '$25', '$50'],
  allowCustomAmount: 'Yes',
  allowAnonymousDonation: 'Yes',
  allowDonorMessage: 'Yes',
  enableLandingPageDonation: 'Yes',
})

export const hydrateCampaignFormData = (campaign) => {
  const formData = campaign?.formData || {}
  const participants = Array.isArray(campaign?.participants)
    ? campaign.participants.map((participant) => ({
        name: participant.name || '',
        email: participant.email || '',
        goal:
          participant.goalAmount !== undefined &&
          participant.goalAmount !== null
            ? String(participant.goalAmount)
            : '',
      }))
    : Array.isArray(formData.participants)
      ? formData.participants
      : []

  return {
    ...createInitialFormData(),
    ...formData,
    campaignName: formData.campaignName || campaign?.title || '',
    description: formData.description || campaign?.description || '',
    goalAmount:
      formData.goalAmount !== undefined && formData.goalAmount !== ''
        ? String(formData.goalAmount)
        : campaign?.goalAmount
          ? String(campaign.goalAmount)
          : '',
    startDate: formData.startDate || campaign?.startDate || '',
    endDate: formData.endDate || campaign?.endDate || '',
    status: campaign?.status === 'active' ? 'Active' : 'Draft',
    pageUrlSlug: slugifyPathSegment(
      formData.pageUrlSlug || campaign?.slug || ''
    ),
    primaryColor: formData.primaryColor || campaign?.primaryColor || '#0057b8',
    participants,
    bannerImageUrl: campaign?.bannerImageUrl || null,
    bannerImageId: campaign?.bannerImageId || null,
    sponsorLogoUrl: campaign?.sponsors?.[0]?.logoUrl || null,
    sponsorLogoId: campaign?.sponsors?.[0]?.logoId || null,
  }
}
